module.exports = __webpack_public_path__ + "img/dd.20e9a4ac.png";